/**
 * Skips over a specified number of documents from the pipeline and returns the rest.
 *
 * @param collection An iterator
 * @param expr
 * @param  {Options} options
 * @returns {*}
 */
export const $skip = (collection, expr, options) => {
    return collection.drop(expr);
};
